export const FETCH_STONE_CUT_REQUEST = 'FETCH_STONE_CUT_REQUEST';
export const FETCH_STONE_CUT_SUCCESS = 'FETCH_STONE_CUT_SUCCESS';
export const FETCH_STONE_CUT_FAILURE = 'FETCH_STONE_CUT_FAILURE';

export const ADD_STONE_CUT_REQUEST = 'ADD_STONE_CUT_REQUEST';
export const ADD_STONE_CUT_SUCCESS = 'ADD_STONE_CUT_SUCCESS';
export const ADD_STONE_CUT_FAILURE = 'ADD_STONE_CUT_FAILURE';

export const UPDATE_STONE_CUT_REQUEST = 'UPDATE_STONE_CUT_REQUEST';
export const UPDATE_STONE_CUT_SUCCESS = 'UPDATE_STONE_CUT_SUCCESS';
export const UPDATE_STONE_CUT_FAILURE = 'UPDATE_STONE_CUT_FAILURE';

export const DELETE_STONE_CUT_REQUEST = 'DELETE_STONE_CUT_REQUEST';
export const DELETE_STONE_CUT_SUCCESS = 'DELETE_STONE_CUT_SUCCESS';
export const DELETE_STONE_CUT_FAILURE = 'DELETE_STONE_CUT_FAILURE';

export const STONE_CUT_FORM_ERROR = 'STONE_CUT_FORM_ERROR';
export const STONE_CUT_FORM_SUCCESS = 'STONE_CUT_FORM_SUCCESS';
export const SET_STONE_CUT_EDIT = 'SET_STONE_CUT_EDIT';
export const CLEAR_STONE_CUT_EDIT = 'CLEAR_STONE_CUT_EDIT'; 